import { render, staticRenderFns } from "./JdsRichRadioGroup.vue?vue&type=template&id=f5318820&scoped=true&"
import script from "./JdsRichRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./JdsRichRadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./JdsRichRadioGroup.vue?vue&type=style&index=0&id=f5318820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5318820",
  null
  
)

export default component.exports